import { Route, Routes, useLocation } from "react-router-dom";
import KakaoLogin from "routes/account/signIn/KakaoLogin";
import MemberSignIn from "routes/account/signIn/MemberSignIn";
import SignUp from "routes/account/signUp/SignUp";
import FrontLayout from "routes/front/FrontLayout";
import Home from "routes/front/Home";
import PrivacyPolicy from "routes/front/footer/PrivacyPolicy";
import ShippingPolicy from "routes/front/footer/ShippingPolicy";
import TermsOfUse from "routes/front/footer/TermsOfUse";
import Main from "routes/front/main/Main";
import Main2 from "routes/front/main/Main2";
import WebSocketContainer from "routes/front/main/WebSocketContainer";
import MobileLodingPage from "routes/front/main/vending/MobileLodingPage";
import MobileMypage from "routes/front/main/vending/MobileMypage";
import PointRecharge from "routes/mobile/point/PointRecharge";
import Receipt from "routes/mobile/receipt/Receipt";
import ReceiptDetail from "routes/mobile/receipt/ReceiptDetail";
import Complete from "routes/order/Complete";
import FailPage from "routes/order/FailPage";
import PaymentGateway from "routes/order/PaymentGateway";
import PaymentGateway2 from "routes/order/PaymentGateway2";
import Payment from "routes/order/purchaseOrder/Payment";
import PointPayment from "routes/order/purchaseOrder/PointPayment";
import RequireAuth from "shared/utils/RequireAuth";

import MobileLayout from "routes/front/mobile/MobileLayout";
import Main3 from "routes/front/main/Main3";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { useContext, useEffect } from "react";
import { getLocalStorage, getRoleFromTokenPayload, getTokenPayload } from "shared/utils/Utils";
import TestMain from "routes/front/main/TestMain";
import ResponsiveHome from "routes/main/home/ResponsiveHome";
import ResponsiveHomeLayout from "routes/main/home/ResponsiveHomeLayout";
import ProductList from "routes/main/home/productList/ProductList";
import ProductDetail from "routes/main/home/productList/ProductDetail";
import CartPage from "routes/main/home/cart/CartPage";
import OrderSummaryPage from "routes/main/home/order/OrderSummaryPage";
import ResponsiveHomeLayout2 from "routes/main/home/ResponsiveHomeLayout2";
import PaymentPage from "routes/main/home/payment/PaymentPage";
import PaymentGatewayPage from "routes/main/home/payment/PaymentGatewayPage";
import PaymentFailPage from "routes/main/home/payment/PaymentFailPage";
import PaymentSuccessPage from "routes/main/home/payment/PaymentSuccessPage";
import HomePageLogin from "routes/main/home/login/HomePageLogin";
import ResponsiveHomeLayoutType from "routes/main/home/ResponsiveHomeLayoutType";

import MyPageLayout from "routes/account/mypage/MyPageLayout";
import MyPageInfo from "routes/account/mypage/MyPageInfo";
import TrackOrder from "routes/main/home/mypage/TrackOrder";
import Restock from "routes/main/home/mypage/Restock";
import Payment2 from "routes/order/purchaseOrder/Payment2";
import TestUploadPage from "routes/front/test/TestUploadPage";
import MainPage from "routes/front/main/vending/mainPage/MainPage";
import TestPage from "routes/front/test/TestPage";
import PaymentComplete from "routes/order/PaymentComplete";
import MobileScan from "routes/front/mobile/MobileScan";
import MobileHome from "routes/front/mobile/MobileHome";
import MobileSetting from "routes/front/mobile/MobileSetting";
import VendingLayout from "routes/front/main/vending/mainPage/layout/VendingLayout";
import AddtoCartStep from "routes/front/main/vending/mainPage/layout/process/AddtoCartStep";
import PaymentStep from "routes/front/main/vending/mainPage/layout/process/PaymentStep";
import ReceiveItemStep from "routes/front/main/vending/mainPage/layout/process/ReceiveItemStep";
import ModalTestPage from "routes/front/test/ModalTestPage";
import MemberWithdrawal from "routes/account/withdrawal/MemberWithdrawal";
import MobileAndroidLayout from "routes/front/mobile/android/MobileAndroidLayout";
import MobileAndroidMypage from "routes/front/mobile/android/MobileAndroidMypage";
import MobileAndroidScan from "routes/front/mobile/android/MobileAndroidScan";
import AndroidReceipt from "routes/front/mobile/android/receipt/AndroidReceipt";
import AndroidReceiptDetail from "routes/front/mobile/android/receipt/AndroidReceiptDetail";
import AndroidMemberWithdrawal from "routes/front/mobile/android/withdrawal/AndroidMemberWithdrawal";
import MobileAndroidSetting from "routes/front/mobile/android/MobileAndroidSetting";
import MobileProductlist from "routes/front/mobile/MobileProductList";
import MobileCartList from "routes/front/mobile/MobileCartList";

import PuffuOrderPaymentGateway from "routes/order/PuffuOrderPaymentGateway";
import PuffuOrderPaymentComplete from "routes/order/PuffuOrderPaymentComplete";
import PuffuOrderPayment from "routes/order/PuffuOrderPayment";
import PuffuOrderProductDetail from "routes/main/home/productList/PuffuOrderProductDetail";
import VendingSignIn from "routes/front/main/vending/VendingSignIn";
import TestPage1 from "routes/front/test/TestPage1";
import TestReciveProduct from "routes/front/main/vending/mainPage/layout/process/TestReciveProduct";
import MobileNumberSignIn from "routes/account/signIn/MobileNumberSignIn";

import MemberSignUp from "routes/account/signUp/MemberSignUp";
import MobileSignUpComplete from "routes/front/mobile/MobileSignUpComplete";
import TestPageResult from "routes/front/test/TestPageResult";
import TestadminApp from "routes/front/test/TestadminApp";
import AppRedirect from "routes/account/signUp/AppRedirect";
import MemberNumberSignUpAndSignIn from "routes/account/signUp/MemberNumberSignUpAndSignIn";
import VideoPlayer from "routes/video/VideoPlayer";
import ProductRadar from "routes/front/main/vending/mainPage/layout/process/product/ProductRadar";
import ProductReview from "routes/mobile/review/ProductReview";
import PaymentLanding from "routes/front/mobile/payment/PaymentLanding";
import PaymentLandingGateway from "routes/front/mobile/payment/PaymentLandingGateway";
import Error404Page from "components/404/Error404Page";
import VendingComplete from "routes/front/mobile/complete/VendingComplete";
import AppDown from "routes/front/mobile/app/AppDown";
import StoreList from "routes/front/mobile/store/StoreList";
import { AuthContext } from "providers/AuthProvider";
import { useDispatch } from "react-redux";
import { requester } from "App";
import { FavoriteReducer } from "shared/redux/reducers/shopping/FavoriteReducer";
import QrTest from "routes/main/test/QrTest";
import ExhibitionView from "routes/front/main/vending/mainPage/layout/process/exhibition/ExhibitionView";
import HorizontalHome from "routes/front/HorizontalHome";
import HorizontalVendingLayout from "routes/front/main/vending/mainPage/layout/horizontal/HorizontalVendingLayout";
import HorizontalAddtoCartStep from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalAddtoCartStep";
import HorizontalPaymentStep from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalPaymentStep";
import HorizontalReceiveItemStep from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalReceiveItemStep";
import HorizontalHome2 from "routes/front/HorizontalHome2";
import HorizontalVendingLayout2 from "routes/front/main/vending/mainPage/layout/horizontal/HorizontalVendingLayout2";
import HorizontalAddtoCartStep2 from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalAddtoCartStep2";
import HorizontalPaymentStep2 from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalPaymentStep2";
import HorizontalReceiveItemStep2 from "routes/front/main/vending/mainPage/layout/horizontal/process/HorizontalReceiveItemStep2";
import GLTFModelViewer2 from "routes/3d/GLTFModelViewer2";
import LottieAnimation from "routes/front/test/mok/TestLottieAnimation";
import TestDevicePage from "routes/front/test/TestDeivcePage";
import PaymentHistoryGateway from "routes/front/mobile/payment/PaymentHistoryGateway";
import DemoLayout from "routes/front/DemoLayout";
import DemoHome from "routes/front/DemoHome";
import DemoVendingLayout from "routes/front/main/vending/mainPage/layout/horizontal/DemoVendingLayout";
import DemoAddtoCartStep from "routes/front/main/vending/mainPage/layout/horizontal/process/DemoAddtoCartStep";
import DemoPaymentStep from "routes/front/main/vending/mainPage/layout/horizontal/process/DemoPaymentStep";
import DemoReceiveItemStep from "routes/front/main/vending/mainPage/layout/horizontal/process/DemoReceiveItemStep";
import Test from "components/404/Test";
import PartnesSignIn from "routes/account/signIn/PartnesSignIn";
import WebsocketTestTool from "routes/front/test/WebsocketTestTool";
import VideoUploadTestPage from "routes/front/test/VideoUploadTestPage";
import Contract from "routes/admin/contract/Contract";

function FrontRouter({ allowedRoles }) {
    const location = useLocation();
    const [token, setToken] = useLocalStorage("token");
    let tokenPayload = getTokenPayload(token);
    const { isAuthenticated } = useContext(AuthContext);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAuthenticated === true) {
            requester.findAllbyFavorites((result) => {
                if (result.code === 0) {
                    dispatch(FavoriteReducer.actions.refreshFavorites(result.data));
                }
            });
        } else {
            dispatch(FavoriteReducer.actions.reset());
        }
    }, [isAuthenticated]);

    return (
        <Routes location={location}>
            <Route path="contract" element={<Contract />} />
            <Route path="demo" element={<DemoLayout />} />
            <Route path="qrtest" element={<QrTest />} />
            <Route path="test111" element={<Test />} />
            <Route path="123" element={<LottieAnimation />} />
            <Route path="*" element={<Error404Page />} />
            <Route path="appDown" element={<AppDown />} />
            <Route path="vendingComplete" element={<VendingComplete />} />
            <Route path="mobile" element={<MobileLayout />} />
            <Route path="mobileNumber" element={<MobileNumberSignIn />} />
            <Route path="memberAccess" element={<MemberNumberSignUpAndSignIn />} />
            {/* <Route path="" element={<RequireAuth />}> */}
            <Route path={"test3"} element={<TestUploadPage />} />
            <Route path="test4" element={<TestDevicePage />} />
            <Route path="test5" element={<WebsocketTestTool />} />
            {/* <Route path={"testRadar"} element={<ProductRadar />} />
            <Route path={"testtest"} element={<TestPage1 />} /> */}
            <Route path="/login" element={<MemberSignIn footer />} />
            <Route path="/partnersLogin" element={<PartnesSignIn footer />} />
            <Route path="/appRedirect" element={<AppRedirect />} />
            <Route path="/signUp" element={<MemberSignUp />} />
            <Route path="/signUp/complete" element={<MobileSignUpComplete />} />
            {/* <Route path="/videoTest" element={<VideoPlayer />} /> */}
            <Route path="/mypage" element={<MobileMypage />} />
            <Route path="/termsOfUse" element={<TermsOfUse />} />
            <Route path="signUp/result" element={<TestPageResult />} />
            <Route path="appTest" element={<TestPage />} />
            <Route path="/ws/:id" element={<WebSocketContainer />} >
                <Route path="paymentHistory" element={<PaymentHistoryGateway />} />
                <Route path="landing" element={<PaymentLanding />} />
                <Route path="landingGateWay" element={<PaymentLandingGateway />} />
                <Route path="vendingSignIn" element={<VendingSignIn />} />
                <Route path="mobile" element={<MobileLayout />}>
                    <Route path="" element={<MobileHome />} />
                    <Route path="scan" element={<MobileScan />} />
                    <Route path="setting" element={<MobileSetting />} />
                    <Route path="withdrawal" element={<MemberWithdrawal />} />
                    <Route path="storeList" element={<StoreList />} />
                    <Route path="list" element={<MobileProductlist />} />
                    <Route path="cart" element={<MobileCartList />} />
                    <Route path="detail/:productId" element={<PuffuOrderProductDetail />} />
                    <Route path="receipt">
                        <Route path="" element={<Receipt />} />
                        <Route path="detail/:orderId" element={<ReceiptDetail />} />
                        <Route path="review/:orderId" element={<ProductReview />} />
                    </Route>
                </Route>
                {/* 이전 안드로이드용 페이지 */}
                {/* <Route path="mobile/android" element={<MobileAndroidLayout />}>
                    <Route path="" element={<MobileAndroidMypage />} />
                    <Route path="scan" element={<MobileAndroidScan />} />
                    <Route path="setting" element={<MobileAndroidSetting />} />
                    <Route path="withdrawal" element={<AndroidMemberWithdrawal />} />
                    <Route path="receipt">
                        <Route path="" element={<AndroidReceipt />} />
                        <Route path="detail/:orderId" element={<AndroidReceiptDetail />} />
                    </Route>
                </Route> */}
                {/* 이전 안드로이드용 페이지 끝 (정리예정) */}
                {/* 웹, 모바일  */}
                {/* <Route path="homePage" element={<ResponsiveHomeLayoutType />} >
                    <Route path="login" element={<HomePageLogin />} />
                    <Route path="" element={<ResponsiveHome />} />
                    <Route path="list/:categoryId" element={<ProductList />} />
                    <Route path="detail/:productId" element={<ProductDetail />} />
                    <Route path="cart" element={<CartPage />} />
                    <Route path="mypage" element={<MyPageLayout />} >
                        <Route path="" element={<MyPageInfo />} />
                        <Route path="trackOrder" element={<TrackOrder />} />
                        <Route path="restock" element={<Restock />} />
                    </Route>
                    <Route path="orderSummary/:productId" element={<OrderSummaryPage />} />
                    <Route path="payment" >
                        <Route path="" element={<PaymentPage />} />
                        <Route path="gateway" element={<PaymentGatewayPage />} />
                        <Route path="complete" element={<PaymentSuccessPage />} />
                        <Route path="fail" element={<PaymentFailPage />} />
                    </Route>
                    <Route path="termsOfUse" element={<TermsOfUse />} />
                    <Route path="privacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="shippingPolicy" element={<ShippingPolicy />} />
                </Route> */}
                {/* 웹 모바일 끝 */}



                {/* <Route path="testRecive" element={<TestReciveProduct />} /> */}
                {/* 키오스크 관련 */}
                {/* <Route path="horizontal">
                    <Route path="home" element={<HorizontalHome />} />
                    <Route path="main" element={<HorizontalVendingLayout />} >
                        <Route path="" element={<HorizontalAddtoCartStep />} />
                        <Route path="payment" element={<HorizontalPaymentStep />} />
                        <Route path="receiveItem" element={<HorizontalReceiveItemStep />} />
                    </Route>
                </Route> */}
                {/* <Route path="horizontal2"> */}
                    <Route path="home" element={<HorizontalHome2 />} />
                    <Route path="main" element={<HorizontalVendingLayout2 />} >
                        <Route path="" element={<HorizontalAddtoCartStep2 />} />
                        <Route path="payment" element={<HorizontalPaymentStep2 />} />
                        <Route path="receiveItem" element={<HorizontalReceiveItemStep2 />} />
                    </Route>
                {/* </Route> */}
                {/* <Route path="home" element={<Home />} /> */}
                {/* <Route path="" element={<FrontLayout />}>
                    <Route path="main" element={<VendingLayout />} >
                        <Route path="" element={<AddtoCartStep />} />
                        <Route path="payment" element={<PaymentStep />} />
                        <Route path="receiveItem" element={<ReceiveItemStep />} />
                        {/* <Route path="exhibition" element={<ExhibitionView />} /> */}
                    {/* </Route>
                </Route> */} 


                <Route path={"demoKiosk"}>
                    <Route path="home" element={<DemoHome />} />
                    <Route path="main" element={<DemoVendingLayout />} >
                        <Route path="" element={<DemoAddtoCartStep />} />
                        <Route path="payment" element={<DemoPaymentStep />} />
                        <Route path="receiveItem" element={<DemoReceiveItemStep />} />
                    </Route>
                </Route>

                {/* 키오스크 관련 끝 */}
                <Route path="payment">
                    <Route path="puffuOrder">
                        <Route path="" element={<PuffuOrderPayment />} />
                        <Route path="gateway" element={<PuffuOrderPaymentGateway />} />
                        <Route path="complete" element={<PuffuOrderPaymentComplete />} />
                    </Route>
                    <Route path="" element={<Payment2 />} />
                    <Route path="point" element={<PointPayment />} />
                    <Route path="gateway" element={<PaymentGateway />} />
                    <Route path="gateway2" element={<PaymentGateway2 />} />
                    <Route path="complete" element={<PaymentComplete />} />
                </Route>


                <Route path="signUp" element={<SignUp />} />
                <Route path="pointRecharge" element={<PointRecharge />} />
                <Route path="complete" element={<Complete />} />
                <Route path="demoComplete" element={<Complete />} />
                <Route path="fail" element={<FailPage />} />

                {/* <Route path="test" element={<TableComponent />} /> */}
                {/* <Route path="order">
                        <Route path="" element={<Order />} />
                        <Route path="complete" element={<OrderComplete />} />
                    </Route> */}



                {/* <Route path="kakaoLogin" element={<KakaoLogin />} /> */}

            </Route>


        </Routes>
    );
}

export default FrontRouter;